export const emailRegex =
  /^[A-Za-z0-9]{1}[+A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]+\.[A-Za-z0-9]+$/;
